export default "__VITE_ASSET__BCCc6JHd__"